import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Stack, Typography } from '@packages/shared';
import { Joe, PaybackColored32 } from '@packages/themes/icons';
import { useIntl } from 'react-intl';
import { bonusPointsMessages } from './messages';

const BonusPointsFragment = graphql(/* GraphQL */ `
  fragment BonusPointsFragment on Bonuspoints {
    points
    type
  }
`);

type BonusPointsProps = {
  data: FragmentType<typeof BonusPointsFragment>;
};

/**
 * This component is used to render either Joe or Payback bonus points.
 */
export const BonusPoints = ({ data: bonusPointsData }: BonusPointsProps) => {
  const { points, type } = getFragmentData(BonusPointsFragment, bonusPointsData);
  const { formatMessage } = useIntl();

  if (!(type === 'JOE' || type === 'PAYBACK')) return null;

  const Icon = type === 'PAYBACK' ? PaybackColored32 : Joe;

  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <Icon sx={{ fontSize: '1rem' }} />
      <Typography component="span" variant="body1" sx={{ fontWeight: 'fontWeightSemiBold' }}>
        {formatMessage(bonusPointsMessages[type], {
          value: points,
        })}
      </Typography>
    </Stack>
  );
};
